import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  leftPanel: {
    flex: '0 1',
    borderRight: '1px solid #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 100%',
      borderRight: 'none',
      borderBottom: '1px solid #E2EBF6'
    }
  },
  tabTitle: {
    fontSize: 15,
    display: 'inline',
    paddingLeft: '30px',
    color: '#071B27', 
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      paddingLeft: '15px'
    }
  },
  statisticTab: {
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #E2EBF6',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  chartLegend: {
    width: '220px',
    padding: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '10px'
    }
  },
  legendTitle: {
    fontSize: '37px',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px'
    }
  },
  chartWrapper: {
    paddingTop: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '10px'
    }
  }
}));

export default useStyles;
